import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'
import { useViewMode } from '@/stores/viewMode'

interface PatientFlowStats {
  today: number
  yesterday: number
}

export function useClinicPatientFlowStats(clinicId?: number) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<PatientFlowStats>>(
    token && clinicId ? `/api/clinic-patient-flow/${clinicId}/stats` : null,
    undefined,
    token ?? '',
  )

  return {
    flowStats: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}

export function useAllClinicsPatientFlowStats() {
  const { token } = useAuth()
  // Provider mode (sys_admin drilled in or provider user) → pass providerId so the
  // backend can scope the aggregate to that provider.
  const { mode, id: viewModeId } = useViewMode()
  const providerId = mode === 'provider' && viewModeId ? viewModeId : undefined
  const query = providerId ? `?providerId=${providerId}` : ''

  const { data, error, mutate, isLoading } = useGet<ApiResponse<PatientFlowStats>>(
    token ? `/api/clinic-patient-flow/all/stats${query}` : null,
    undefined,
    token ?? '',
  )

  return {
    flowStats: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}
